import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { stylesQueryOptions } from '@/app/(client)/my-styles/-hooks/useStylesQuery';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(list)/components/archived/',
)({
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    ...(search.sort !== undefined ? { sort: search.sort } : {}),
    ...(search.filters !== undefined ? { filters: search.filters } : {}),
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      stylesQueryOptions({ ...deps, isArchived: true, isComponent: true }),
    ),
  component: lazyRouteComponent(
    () => import('../../../../-components/ComponentsArchiveTab'),
    'ComponentsArchiveTab',
  ),
});
